/**
 * Site-wide footer — matches aitrafficlight.com footer layout.
 * Careers | Press | Privacy | Terms | EULA
 * ●●● AI Traffic Light™ / powered by Guardrail Technologies™
 * © 2026 Guardrail Technologies, Inc.™ · Security at the Speed of AI.™
 */

import { TrafficLightLogo } from '@/components/TrafficLightLogo';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-zinc-800 bg-[rgb(5,5,5)] mt-auto">
      <div className="max-w-4xl mx-auto px-6 py-10 flex flex-col items-center gap-6 text-center">
        {/* Nav links */}
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-zinc-500">
          <a href="https://guardrail.tech/careers" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors">Careers</a>
          <a href="mailto:PR@guardrail.tech" className="hover:text-emerald-400 transition-colors">Press</a>
          <a href="https://guardrail.tech/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors">Privacy</a>
          <a href="https://guardrail.tech/terms" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors">Terms</a>
          <a
            href="https://github.com/Guardrail-Documents/Licensing/blob/main/aitrafficlight.com%20END-USER%20LICENSE%20AGREEMENT.md"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-emerald-400 transition-colors"
          >
            EULA
          </a>
        </nav>

        {/* Divider */}
        <div className="w-16 h-px bg-zinc-800" />

        {/* Logo mark — CSS-based matching marketing site */}
        <a href="https://aitrafficlight.com" className="flex flex-col items-center">
          <TrafficLightLogo size="sm" showSub />
        </a>

        {/* Copyright */}
        <p className="text-xs text-zinc-600 max-w-md">
          © {year} Guardrail Technologies, Inc.™ · Security at the Speed of AI.™
        </p>
      </div>
    </footer>
  );
}
